$(document).ready(function() {
  var typingTimer;
  var doneTypingInterval = 100;

  $('.site-header__search-container input[name="q"].site-header__search-input').on('input', function () {
    clearTimeout(typingTimer);
  });

  $('.site-header__search-container input[name="q"].site-header__search-input').on('search', function () {
    var searchText = $('.site-header__search input[name="q"].site-header__search-input').val();
    if(searchText == '') {
      $('#predictive-results__wrapper').removeClass('active');
      $('.overlay').removeClass('active');
      $('body').removeClass('overflow-none');
      return false;
    }
  });

  $('.site-header__search-container input[name="q"].site-header__search-input').on('keyup', function () {
    typingTimer = setTimeout(function() {
      var searchText = $('.site-header__search input[name="q"].site-header__search-input').val();
      if(searchText == '') {
        $('#predictive-results__wrapper').removeClass('active');
        $('.overlay').removeClass('active');
        $('body').removeClass('overflow-none');
        return false;
      }
      $.ajax({
        url: `/search?q=${searchText}&view=ajax&type=product`,
        method: 'POST',
        success: function (data) {
          $('body').addClass('overflow-none');
          $('#predictive-results__wrapper').html(data);
          $('#predictive-results__wrapper').addClass('active');
          $('.overlay').addClass('active');
        }
      });
    }, doneTypingInterval);
  });

  $('.overlay').click(function(params) {
    $('#predictive-results__wrapper').removeClass('active');
    $('.overlay').removeClass('active');
    $('body').removeClass('overflow-none');
    $('input[name="q"]').val('');
  })


  $('input[name="q"].site-header__search-input-mobile').on('input', function () {
    clearTimeout(typingTimer);
  });

  $('input[name="q"].site-header__search-input-mobile').on('search', function () {
    var searchText = $('input[name="q"].site-header__search-input-mobile').val();
    if(searchText == '') {
      $('#predictive-results__wrapper_mobile').removeClass('active');
      $('.site-header-sticky').removeClass('active_search');
      $('.overlay').removeClass('active');
      $('body').removeClass('overflow-none');
      return false;
    }
  });

  $('input[name="q"].site-header__search-input-mobile').on('keyup', function () {
    typingTimer = setTimeout(function() {
      var searchText = $('input[name="q"].site-header__search-input-mobile').val();
      if(searchText == '') {
        $('#predictive-results__wrapper_mobile').removeClass('active');
        $('.site-header-sticky').removeClass('active_search');
        $('.overlay').removeClass('active');
        $('body').removeClass('overflow-none');
        return false;
      }
      $.ajax({
        url: `/search?q=${searchText}&view=ajax&type=product`,
        method: 'POST',
        success: function (data) {
          $('body').addClass('overflow-none');
          $('#predictive-results__wrapper_mobile').html(data);
          $('#predictive-results__wrapper_mobile').addClass('active');
          $('.site-header-sticky').addClass('active_search');
          $('.overlay').addClass('active');
        }
      });
    }, doneTypingInterval);
  });
  $(document).on("click",".mobile-js-search-header-close",function() {
    $('#predictive-results__wrapper_mobile').removeClass('active');
    $('input[name="q"].site-header__search-input-mobile').val('');
    $('body').removeClass('overflow-none');
  });
});